import docCookies from 'doc-cookies';
import { Modal } from 'bootstrap';
import {
  BASE_ARES_URL,
  BASE_URL_SANCTUM,
  FROM_THREE_ATTENDEES,
  FROM_TWO_WITHOUT_FIRST,
  NO_DISCOUNT,
  BASE_ORDER_URL,
  ORDER_TTL,
} from '../misc/consts';
import Iodine from '@kingshott/iodine';
var modal = null;

const iodine = new Iodine();

const defaultOrderState = function (ticketData) {
  return {
    attendees: [],
    company: {
      cin: '',
      city: null,
      company_name: null,
      delivery_address_differ: false,
      land_registry_house_number: null,
      street: null,
      vat_id: null,
      zip: null,
      delivery_address: {
        city: null,
        land_registry_house_number: null,
        street: null,
        zip: null,
      },
    },
    activeAttendee: 0,
    attendanceType: null,
    createdAt: new Date(),
    email: null,
    invited_by: null,
    marketingAgreement: false,
    payment_preference: null,
    promo: null,
    showSecondStep: false,
    ticketId: ticketData ? ticketData.ticket.id : null,
  };
};

const defaultAttendeesState = function (ticketData) {
  if (ticketData.conference.optional_items.length) {
    if (ticketData.ticket.organization) {
      return {
        optionalItems: ticketData.conference.optional_items.filter((option) => {
          return option.available_for_organization;
        }),
      };
    } else {
      return {
        optionalItems: ticketData.conference.optional_items.map(function () {
          return null;
        }),
      };
    }
  }
  return {};
};

export default function (ticketData) {
  return {
    attendee: defaultAttendeesState(ticketData),
    order: this.$persist(defaultOrderState(ticketData)),
    ticketData: ticketData,
    error: null,
    note: null,
    saleActivated: false,
    somethingWentWrong: false,
    termsAndConditionsAgreement: false,
    disableRegistration: false,
    first_name: { errorMessage: '', blurred: false },
    last_name: { errorMessage: '', blurred: false },
    company: { errorMessage: '', blurred: false },
    role: { errorMessage: '', blurred: false },
    email: { errorMessage: '', blurred: false },
    phone: { errorMessage: '', blurred: false },
    cin: { errorMessage: '', blurred: false },
    vat_id: { errorMessage: '', blurred: false },
    company_name: { errorMessage: '', blurred: false },
    street: { errorMessage: '', blurred: false },
    city: { errorMessage: '', blurred: false },
    zip: { errorMessage: '', blurred: false },
    street_mailing: { errorMessage: '', blurred: false },
    city_mailing: { errorMessage: '', blurred: false },
    zip_mailing: { errorMessage: '', blurred: false },
    attendee_email: { errorMessage: '', blurred: false },
    invited_by: { errorMessage: '', blurred: false },
    hitSend: false,

    init() {
      if (this.isOutdated || this.ticketChanged) {
        this.resetCart();
        this.orderExpired = true;
      }
      document.addEventListener('DOMContentLoaded', function () {
        modal = new Modal(document.getElementById('modal-attendee-form'));
      });
      this.$locale(document.documentElement.lang);
    },

    get isOutdated() {
      if (this.order === null) {
        return false;
      }

      const diff = Math.abs(
        Math.round(
          new Date(this.order.createdAt).getTime() - new Date().getTime()
        ) /
          1000 /
          60
      );

      if (diff > ORDER_TTL) {
        return true;
      }

      return false;
    },

    get ticketChanged() {
      if (this.order.attendees.length > 0) {
        return this.order.ticketId !== this.ticketData.ticket.id;
      }
      return false;
    },

    get totalAmount() {
      let total = 0;

      if (this.order.attendees.length > 0) {
        if (this.ticketData.ticket.discount_type === FROM_TWO_WITHOUT_FIRST) {
          if (this.order.attendees.length > 1) {
            total =
              (this.order.attendees.length - 1) *
                this.ticketData.ticket.discounted_price +
              this.ticketData.ticket.attendee_price;
          } else {
            total =
              this.order.attendees.length *
              this.ticketData.ticket.attendee_price;
          }
        } else if (
          this.ticketData.ticket.discount_type === FROM_THREE_ATTENDEES
        ) {
          if (this.order.attendees.length > 2) {
            total =
              this.order.attendees.length *
              this.ticketData.ticket.discounted_price;
          } else {
            total =
              this.order.attendees.length *
              this.ticketData.ticket.attendee_price;
          }
        } else {
          total =
            this.order.attendees.length * this.ticketData.ticket.attendee_price;
        }

        // Přičtěte ceny volitelných položek
        this.order.attendees.forEach((attendee) => {
          if (attendee.optionalItems) {
            attendee.optionalItems.forEach((item) => {
              if (item) {
                total += item.price || 0;
              }
            });
          }
        });
      }

      return total;
    },

    get discountInfo() {
      if (this.hasDiscount()) {
        const count = this.countToDiscount(this.order.attendees.length);

        if (count <= 0) {
          return this.$t('sale_activated');
        }

        if (count > 1) {
          return this.$t('sale_participants', { count: count });
        }
        return this.$t('sale_participant');
      }
      return false;
    },

    get addAttendeeButtonText() {
      return this.order.attendees.length > 0
        ? this.$t('add_anotther_attenedd')
        : this.$t('register');
    },

    get incompleteForm() {
      let billingInfoIncomplete =
        !this.validEmail(this.order.email) ||
        this.order.payment_preference === null ||
        this.order.company.city === null ||
        this.order.company.cin === null ||
        this.order.company.company_name === null ||
        this.order.company.street === null ||
        this.order.company.zip === null;

      let deliveryAddressIncomplete = this.order.company.delivery_address_differ
        ? this.order.company.delivery_address.street === null ||
          this.order.company.delivery_address.zip === null ||
          this.order.company.delivery_address.city === null
        : false;
      if (ticketData.ticket.guest_other) {
        return !this.validEmail(this.order.email);
      }

      return (
        this.order.attendees.length === 0 ||
        billingInfoIncomplete ||
        deliveryAddressIncomplete
      );
    },

    async getXsfrToken() {
      const response = await fetch(BASE_URL_SANCTUM);
      if (!response.ok) {
        this.somethingWentWrong = true;
        throw new Error(`Error! status: ${response.status}`);
      }
    },

    async storeOrder() {
      this.somethingWentWrong = false;

      await this.getXsfrToken();

      fetch(BASE_ORDER_URL, {
        body: JSON.stringify({
          ...this.order,
          ticket: this.ticketData,
          total_amount: this.totalAmount,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
          'X-locale': this.$locale(),
        },
        method: 'POST',
      })
        .then(async (response) => {
          if (!response.ok) {
            let errorResponse = await response.json();
            if (errorResponse.error) {
              this.error = errorResponse.error;
              if (errorResponse.status === 'invalid') {
                this.resetCart();
              }
            } else {
              this.error = this.$t('general_error');
            }
            throw new Error('Network response was not OK');
          }
          return response.json();
        })
        .then((ticketData) => {
          if (ticketData.status === 'success') {
            if (window['google_tag_manager']) {
              this.checkoutToDataLayer(ticketData.redirect_url);
            } else {
              window.location = ticketData.redirect_url;
            }
          }
        })
        .catch(() => {
          this.somethingWentWrong = true;
        });
    },

    async getAresData() {
      let cin = this.order.company.cin.replace(/\s/g, '');
      if (cin.length === 8 && !isNaN(cin)) {
        const response = await fetch(`${BASE_ARES_URL}${cin}`);
        if (!response.ok) {
          throw new Error(`Error! status: ${response.status}`);
        }
        const data = await response.json();
        this.order.company = { ...this.order.company, ...data };
      }
    },

    optionWarningCount() {
      return (
        this.attendee.optionalItems.length -
        this.attendee.optionalItems.filter((x) => !!x).length
      );
    },

    blur(event) {
      let ele = event.target;
      this[ele.name].blurred = true;
      let rules = JSON.parse(ele.dataset.rules);
      this[ele.name].errorMessage = this.getErrorMessage(ele.value, rules);
    },

    input(event) {
      let ele = event.target;
      let rules = JSON.parse(ele.dataset.rules);
      this[ele.name].errorMessage = this.getErrorMessage(ele.value, rules);
    },

    submit(ref) {
      let ret = true;
      let inputs = [...this.$refs[ref].querySelectorAll('input[data-rules]')];
      inputs.map((input) => {
        if (
          !iodine.assert(input.value, JSON.parse(input.dataset.rules)).valid
        ) {
          ret = false;
        }
      });
      return ret;
    },

    getErrorMessage(value, rules) {
      this.setErrors();
      let isValid = iodine.assert(value, rules);
      if (isValid !== true) {
        return iodine._validate(value, rules).error;
      }
      return '';
    },

    setErrors() {
      iodine.setErrorMessage('minLength', this.$t('short'));
      iodine.setErrorMessage('required', this.$t('empty'));
      iodine.setErrorMessage('numeric', this.$t('number'));
      iodine.setErrorMessage('email', this.$t('format'));
    },

    addAttendee() {
      if (
        !this.isFormValid(this.$refs['attendees-form']) ||
        !this.submit('attendees-form')
      ) {
        return false;
      }

      if (this.matchDiscountCriteria(this.order.attendees.length + 1)) {
        this.attendee.price = this.ticketData.ticket.discounted_price;
        if (this.ticketData.ticket.discount_type === FROM_THREE_ATTENDEES) {
          this.order.attendees.forEach(
            (attendee) =>
              (attendee.price = this.ticketData.ticket.discounted_price)
          );
        }
      } else {
        this.attendee.price = this.ticketData.ticket.attendee_price;
      }
      this.order.attendees.push(this.attendee);
      this.attendee = defaultAttendeesState(ticketData);

      if (this.order.attendees.length > 0) {
        this.attendee.company = this.order.attendees[0].company;
      }
      modal.hide();
    },

    hasDiscount() {
      if (![NO_DISCOUNT].includes(this.ticketData.ticket.discount_type)) {
        return true;
      }
      return false;
    },

    countToDiscount(attendeesCount) {
      const limit =
        this.ticketData.ticket.discount_type === FROM_TWO_WITHOUT_FIRST ? 2 : 3;
      return limit - attendeesCount;
    },

    isFormValid(form) {
      return form.reportValidity();
    },

    matchDiscountCriteria(attendeesCount) {
      if (this.hasDiscount()) {
        const count = this.countToDiscount(attendeesCount);

        if (count <= 0) {
          return true;
        }
      }
      return false;
    },

    removeAttendee(index) {
      this.order.attendees.splice(index, 1);
      if (!this.matchDiscountCriteria(this.order.attendees.length)) {
        this.order.attendees.forEach(
          (attendee) => (attendee.price = this.ticketData.ticket.attendee_price)
        );
      } else if (
        this.ticketData.ticket.discount_type === FROM_TWO_WITHOUT_FIRST &&
        index == 0
      ) {
        this.order.attendees[0].price = this.ticketData.ticket.attendee_price;
      }
    },

    resetCart() {
      this.order = defaultOrderState(this.ticketData);
      this.saleActivated = false;
      this.ticketError = null;
      setTimeout(() => {
        window.localStorage.removeItem('_x_order');
      }, 100);
    },

    registerParticipation() {
      this.hitSend = true;
      let forms = [
        this.$refs['company-details-form'],
        this.$refs['pament-preferences'],
        this.$refs['registration-confirmation'],
      ];
      if (ticketData.ticket.guest_other) {
        if (
          this.isFormValid(this.$refs['registration-attendance-type']) &&
          this.isFormValid(this.$refs['registration-confirmation'])
        ) {
          if (
            this.order.attendanceType == 'guest' &&
            !this.submit('registration-attendance-type')
          ) {
            return false;
          }
          this.storeOrder();
          return;
        } else {
          return false;
        }
      }
      if (
        !this.isFormValid(this.$refs['company-details-form']) ||
        !this.submit('company-details-form')
      ) {
        return false;
      }
      let isValid = forms.filter((form) => this.isFormValid(form));

      if (this.$refs['optional-items']) {
        if (!this.checkOptionalItems()) {
          return false;
        }
      }
      if (isValid.length === forms.length) {
        this.storeOrder();
      }
    },

    checkOptionalItems() {
      for (let i = 0; i < this.order.attendees.length; i++) {
        for (let j = 0; j < this.order.attendees[i].optionalItems.length; j++) {
          if (!this.order.attendees[i].optionalItems[j]) {
            let name = i + '_' + j;
            this.order.activeAttendee = i;
            let element = document.querySelector(`input[name='${name}']`);
            while (
              !element.classList.contains(
                'registration__optional-items__option'
              )
            ) {
              element = element.parentNode;
            }
            setTimeout(() => {
              const scrollPos =
                element.getBoundingClientRect().top + window.pageYOffset - 100;
              window.scrollTo({ top: scrollPos, behavior: 'smooth' });
            }, 500);
            return false;
          }
        }
      }
      return true;
    },

    selectOptionalItem(attendeeIndex, optionsIndex, item) {
      // Ověření, že cena je číslo, pokud není, nastavte ji na 0
      const itemPrice = item.price || 0;

      // Získání aktuálně vybrané položky (pokud existuje)
      const currentItem =
        this.order.attendees[attendeeIndex].optionalItems[optionsIndex];

      // Pokud již byla nějaká položka vybrána, odečtěte její cenu
      if (currentItem) {
        this.order.totalAmount -= currentItem.price || 0;
      }

      // Aktualizujte volitelnou položku na novou položku
      this.order.attendees[attendeeIndex].optionalItems[optionsIndex] = {
        ...item,
        price: itemPrice,
      };

      // Přičtěte cenu nové volitelné položky k celkové částce
      this.order.totalAmount += itemPrice;
    },

    formatMoney(amount) {
      const formatter = new Intl.NumberFormat(this.$locale(), {
        style: 'currency',
        currency: this.ticketData.ticket.currency.toUpperCase(),
        maximumFractionDigits: 0,
      });

      return formatter.format(amount);
    },

    formatDate(date) {
      const d = new Date(date);
      return d.getDate() + '. ' + (d.getMonth() + 1) + '. ' + d.getFullYear();
    },

    validEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    optionalItems() {
      if (this.ticketData.ticket.organization) {
        return this.ticketData.conference.optional_items.filter((option) => {
          return option.available_for_organization;
        });
      } else {
        return this.ticketData.conference.optional_items;
      }
    },

    showSecondStep() {
      this.order.showSecondStep = true;
      setTimeout(() => {
        let el = document.getElementById('second-step');
        const y = el.getBoundingClientRect().top + window.pageYOffset - 50;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }, 100);
    },

    checkoutToDataLayer(callbackUrl) {
      const dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: 'checkout',
        ecommerce: {
          checkout: {
            actionField: { step: 1 },
            products: this.order.attendees.map((attendee) => {
              return {
                name: this.ticketData.ticket.label_cs,
                id: this.ticketData.conference.slug,
                price: attendee.price,
                variant: this.ticketData.ticket.label_cs,
                quantity: 1,
              };
            }),
          },
        },
        eventCallback: function () {
          window.location = callbackUrl;
        },
        eventTimeout: 1000,
      });
    },
  };
}
